import classNames from 'classnames';
import { ReactNode } from 'react';

export const Hint = ({ children, className }: { children: ReactNode; className?: string }) => (
  <div className={classNames('mt-1 u-color-bark3 u-fs-2', className)}>{children}</div>
);
